const ProfileNavRoutes = [
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('@/views/Profile.vue'),
    meta: { requiresAuth: true, footerIcon: 'profile', titleName: route => {} }
  },
  {
    path: '/favourites',
    component: () => import('@/components/Routable.vue'),
    children: [
      {
        path: '/',
        name: 'Favs',
        component: () => import('@/views/MixedView/index.vue'),
        props: route => ({
          actionProps: {
            mainAction: 'GET_NEXT_LIKES',
            resetAction: 'RESET_LIKES_ACTION'
          },
          getterProps: ['getFavsData', 'getFavsRefs'],
          actionParamsProps: null
        }),
        meta: {
          requiresAuth: true,
          footerIcon: 'profile',
          titleName: route => 'Mis favoritos'
        }
      },
      {
        path: 'posts/:postId',
        name: 'SinglePostFav',
        component: () => import('@/views/singlePost.vue'),
        meta: {
          requiresAuth: true,
          footerIcon: 'profile',
          titleName: route => 'Noticia'
        }
      }
    ]
  },
  {
    path: '/edit-profile',
    name: 'EditProfile',
    component: () => import('@/views/EditProfile.vue'),
    meta: {
      requiresAuth: true,
      footerIcon: 'profile',
      titleName: route => 'Editar perfil'
    }
  }
]
export default ProfileNavRoutes



// WEBPACK FOOTER //
// ./src/router/profile.js